


import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./Components/ThemeProvider";

import Navbar from "./Components/Navbar";
import Hero from "./Components/Hero";
import WhatIsNFC from "./Components/WhatIsNFC";
import About from "./Components/About";
import WhyChoose from "./Components/WhyChoose";
import SEOSection from "./Components/SEOSection";
import TwoClicks from "./Components/TwoClicks";
import CardModels from "./Components/CardModels";
import HowItWorks from "./Components/HowItWorks";
import SocialMediaSynergy from "./Components/SocialMediaSynergy";
import Pricing from "./Components/Pricing";
import Contact from "./Components/Contact";
import Footer from "./Components/Footer";
import CardBuilder from "./Components/CardBuilder";
import CardUrl from "./Components/cardbuilder/CardUrl";
import Vfccard from './Components/VFCCard/Vfccard';
import Profile from "./Components/cardbuilder/Profile";
import PasswordResetForm from "./Components/Auth/PasswordResetFrom";
import ProtectedRoute from "./Components/Auth/ProtectedRoute";
import AdminApproval from "./Components/Auth/AdminApproval";



function Home() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <Hero />
      <WhatIsNFC />
      <About />
      <WhyChoose />
      <SEOSection />
      <TwoClicks />
      <CardModels />
      <HowItWorks />
      <SocialMediaSynergy />
      <Pricing />
      <Contact />
      <Footer />
    </div>
  );
}

export default function App() {



  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
           <Route path="/adminapproval" element={<AdminApproval />} />
          <Route path="/builder" element={<ProtectedRoute><CardBuilder /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/vfc-card" element={<ProtectedRoute><Vfccard /></ProtectedRoute>} />

          <Route path="/cardurl/:websiteUrl" element={<CardUrl />} />
          <Route path="/reset-password/:token" element={<PasswordResetForm />} />
        </Routes>

      </BrowserRouter>
    </ThemeProvider>
  );
}







